import React from 'react'
import { Link } from 'react-router-dom'


export default function Contact() {
  return (
    <Link to={"/home"}>Home</Link>
  )
}
